<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-input v-model="listQuery['filter[name]']" placeholder="考试名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="addExam">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" stripe style="width: 100%" center>
      <el-table-column type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" label="考试编号" width="100">
      </el-table-column>
      <el-table-column prop="name" label="考试名称" width="180" >
      </el-table-column>
      <el-table-column prop="address" label="考试时间" >
        <template slot-scope="scope">
          {{$format(scope.row.begin_dt,'yyyy-MM-dd hh:mm')}}~{{$format(scope.row.end_dt,'yyyy-MM-dd hh:mm')}}
        </template>
      </el-table-column>
      <el-table-column prop="constitute" label="考试组成" width="100">
      </el-table-column>
      <el-table-column prop="total" label="考试人数" width="100">
      </el-table-column>
      <el-table-column prop="address" label="排考状态" width="50">
        <template slot-scope="scope">
          <span :style="{color:scope.row.arranged==1?'#67C23A':'#F56C6C'}">{{scope.row.arranged==1?"是":"否"}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <el-button size="mini" type="primary"  @click="goSeting(scope.row)">设置</el-button>
          <el-button size="mini" type="danger"  @click="godel(scope.row)">删除</el-button>
          <el-button size="mini" type="warning"  v-if="scope.row.status==2&&scope.row.real_push==0" @click="goPublish((scope.row))">发布成绩</el-button>
          <el-button size="mini" type="warning"  v-else disabled="disabled">发布成绩</el-button>
          <el-button size="mini" type="default" v-if="scope.row.status==0||scope.row.status==2" disabled="disabled">结束考试</el-button>
          <el-button size="mini" type="default"  v-else  @click="endExam(scope.row)">结束考试</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;margin-top:20px">
      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>
  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: { Pagination },

        data() {
    return {
        listQuery:{
            page: 1,
            per_page:20
        },
       total:0,
      tableData: []
    };
  },
  computed: {

  },
  created() {
    this.getData()
  },
  methods: {
    goPublish(item) {
      this.$http.sendResult({
        exam_id: item.id,
      })
        .then(res => {
          if (res.code == 1) {
            this.$message.success("发布成功")
            this.getData()

          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })

    },
    endExam(item) {
        console.log(item)

        this.$http.finishExam({
        exam_id: item.id,
      })
        .then(res => {
          if (res.code == 1) {
            this.$message.success("操作成功")
            this.getData()

          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })
    },
    //删除考生安排
    godel(item) {
      this.$confirm('确定要删除该数据吗？')
        .then(_ => {
            this.$http.deleteExam({
              id: item.id,

            })
              .then(res => {
                if (res.code !== 0) {
                  this.$message.success("删除成功")
                  this.getData()

                } else {
                  this.$message.error(res.message)
                }

              })
              .catch(err => {
                console.log(err);
              })
        })
        .catch(_ => { });

    },
    goSeting(item) {
      console.log(item)
       window.sessionStorage.removeItem('tabIndex')
       this.$router.push({
        name: 'examSeting',

        query: {
          id: item.id
        }
      }
      )
    },
    addExam() {
      this.$router.push({
        name: 'addExam'
      }
      )
    },
    search() {
      this.getData()
    },
    // 获取全部的课程列表
    getData() {
      this.$http.examsList(this.listQuery)
        .then(res => {
          this.tableData = res.data;
          this.total = res.meta.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
    // getData(){
    //      this.$http.validateCode(params).then(res => {
    //        if(res.code==200){
    //          this.loginHandler();
    //        }else{
    //          this.$message.error(res.message);
    //        }
    //       });
    // },
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      // console.log('当前页:'+ val);
      this.pageform.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/examManage/examArrange.vue